import { useCallback, useRef, useState } from "react";
import { getReportingFields } from "../utils/ladder-util";
import type { ActivityResult, CompletionDisplayData } from "../types";

interface UseSubmissionExtractorOptions {
  onActivitySubmitted: (
    result: ActivityResult,
  ) => Promise<CompletionDisplayData>;
  onSubmissionComplete: (data: CompletionDisplayData) => void;
}

export const useSubmissionExtractor = ({
  onActivitySubmitted,
  onSubmissionComplete,
}: UseSubmissionExtractorOptions) => {
  const [submitting, setSubmitting] = useState(false);
  const onActivitySubmittedRef = useRef(onActivitySubmitted);
  onActivitySubmittedRef.current = onActivitySubmitted;
  const onSubmissionCompleteRef = useRef(onSubmissionComplete);
  onSubmissionCompleteRef.current = onSubmissionComplete;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmitted = useCallback(async (itemsApi: any, divId: string) => {
    try {
      setSubmitting(true);
      const scores = itemsApi.getScores();
      const responses = itemsApi.getResponses();
      const tags = itemsApi.getTags();
      const items = itemsApi.getItems();
      const time = itemsApi.getTime();

      const result: ActivityResult = {
        scores,
        responses,
        tags,
        items,
        time,
        sessionId: itemsApi.forSessionId || "",
        reportingFields: getReportingFields(itemsApi),
      };

      const completionData = await onActivitySubmittedRef.current(result);

      // Hide the learnosity div
      const el = document.getElementById(divId);
      if (el) el.style.display = "none";

      onSubmissionCompleteRef.current(completionData);
    } catch (error) {
      console.error("Error onActivitySubmitted", error);
    } finally {
      setSubmitting(false);
    }
  }, []);

  return { submitting, handleSubmitted };
};
